import {combineLatest, Observable, of, Subject, Subscription} from 'rxjs';
import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UtilsService} from '../../core/utils/utils.service';
import {MenuItem, SelectItem} from 'primeng/api';
import {ProduitDTO} from '../../core/dtos/produit-dto';
import {Auth2Service} from '../../core/services/security/auth2.service';
import {catchError, finalize, switchMap} from 'rxjs/operators';
import {Page, SearchService} from '../../core/services/search.service';
import {RoutemapService} from '../../core/services/routemap.service';
import {DialogMsgSupplier} from '../../core/suppliers/dialog-msg-supplier';
import {ProduitsService} from '../../core/services/entities/produits.service';
import {GenericFormService} from '../../core/services/generics/generic-form.service';
import {GenericDatagridService} from '../../core/services/generics/generic-datagrid.service';
import {ProduitDeclinaisonDTO} from '../../core/dtos/produit-declinaison-dto';
import {
  DialogProduitDeclinaisonSupplier,
  ProduitDeclinaisonService
} from '../../core/services/entities/produit-declinaison.service';
import {ResponseWrapper} from '../../core/suppliers/wrappers/response-wrapper';
import {FamillesProduitService} from '../../core/services/entities/familles-produit.service';
import {FamilleProduitDTO} from '../../core/dtos/famille-produit-dto';
import {TypeProduitDTO} from '../../core/dtos/type-produit-dto';
import {TypesProduitService} from '../../core/services/entities/types-produit.service';
import {SiteDTO} from '../../core/dtos/site-dto';
import {DeclinaisonsService} from '../../core/services/entities/declinaisons.service';
import {DeclinaisonDTO} from '../../core/dtos/declinaison-dto';
import {HAS_GEF, HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from '../../core/constants';
import {ProduitContrainteAlimService} from '../../core/services/entities/produit-contrainte-alim.service';
import {OverlayPanel} from 'primeng/overlaypanel';
import CustomStore from "devextreme/data/custom_store";
import {Sort} from "../../core/suppliers/generics/generic-request-supplier";
import {DevextremeService, FilterItem} from "../../core/services/technique/devextreme.service";
import {DxDataGridComponent} from "devextreme-angular";
import {confirm} from 'devextreme/ui/dialog';
import {RegimeAlimentaireDTO} from "../../core/dtos/regime-alimentaire-dto";
import {RegimeAlimentaireService} from "../../core/services/entities/regime-alimentaire.service";
import {debounceTime} from "rxjs/internal/operators";
import {ToastService} from "../../core/services/technique/toast.service";
import {TextMessageService} from "../../shared/ui/text-messages/textMessage.service";
import {GraphQLService} from "../../core/services/technique/graphql.service";
import {ProduitService} from "../../core/services/gestionproduits/produit.service";
import {ObjectDTO} from "../../core/dtos/object-dto";
import {GestionGefService} from "../../core/services/gef/gestion-gef.service";
import {GefAuditDto} from "../../core/dtos/gef/gef-audit-dto";
import {ButtonThemeEnum} from '../../shared/ui/button/button-theme-enum';
import {SearchProduitsFiltersDto} from '../../core/dtos/produit/search-produits-filters-dto';

@Component({
    selector: 'yo-grilleproduits',
    templateUrl: './grilleproduits.component.html',
    styleUrls: ['./grilleproduits.component.scss'],
    standalone: false
})
export class GrilleproduitsComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  // SUBSCRIPTIONS
  subProduitSubject: Subscription;
  subProduitSubjectToDelete: Subscription;
  subAuth2: Subscription;
  subDeleteProduit: Subscription;
  subGrilleProduits: Subscription;
  subSaveProduitDeclinaison: Subscription;
  subDeleteProduitDeclinaison: Subscription;

  /**
   * Souscription à la récupération des {@link FamilleProduitDTO}s.
   */
  subFamillesProduits: Subscription;

  /**
   * Souscription à la récupération des {@link TypeProduitDTO}s.
   */
  subTypesProduits: Subscription;

  /**
   * Souscription à la récupération des {@link DeclinaisonDTO}s.
   */
  subDeclinaisons: Subscription;

  subRegimes: Subscription;

  @ViewChild('grid') grid: DxDataGridComponent;

  /**
   * La p-overlayPanel pour la duplication de produit
   */
  @ViewChild('opDuplication') opDuplication: OverlayPanel;

  pathFile: string = HELP_FOLDERS.PRODUITS + '/produits';

  openProduitDeclinaison = (produit: ProduitDTO, produitDeclinaison: ProduitDeclinaisonDTO): void => {

    // Probleme dans les cycle de vie Angular RXJS a deja envoyer affecter une valeur a l observable avant une le composant et le temps de s'y abonner
    // d'ou le setTime et le then le dialog existe dans DeclinaisonsProduitComponent (routing necessaire)
    // La ligne de la grille ne porte qu'une version allégée du produit et de ses déclinaisons (sans unité de mesure,
    // tâches, régimes...) : le dialogue a besoin du produit complet, rechargé comme dans l'onglet Déclinaisons.
    this.routeMapSvc.goToSecondaryRoute(['gestionproduits', 'produit', produit.typeProduit.fabrique, produit.id, 'produit-declinaisons']).then(data => {
      this.produitSvc.findByIdWithProduitDeclinaison(produit.id).subscribe((response: ResponseWrapper<ProduitDTO>) => {
        const produitComplet = response.one;
        const produitDeclinaisonComplet = produitDeclinaison
          ? produitComplet.produitDeclinaisons.find(pd => pd.id === produitDeclinaison.id)
          : undefined;
        setTimeout(() => {
          this.produitsDeclinaisonSvc.announceOpenDialogProduitDeclinaison(<DialogProduitDeclinaisonSupplier>{
            produit: produitComplet,
            produitDeclinaison: produitDeclinaisonComplet
          });
        }, 800);
      });
    });
  };

  help = (): DialogMsgSupplier => undefined;

  /**
   * Contient l'intégralité des {@link FamilleProduitDTO}s de premier niveau (cf. {@link FamillesProduitService#removeChildren()}.
   */
  allFamillesProduits: FamilleProduitDTO[];

  /**
   * Les {@link SelectItem}s représentant les {@link FamilleProduitDTO}s.
   */
  allFamillesProduitsItems: FamilleProduitDTO[];

  idsFamillesProduitsSelected: number[] = [];
  idsFamillesProduitsSelectedPrevious: number[] = [];

  allRegimesItems: RegimeAlimentaireDTO[] = [];

  idsRegimesSelected: number[] = [];

  /**
   * Contient l'intégralité des types de produits ({@link TypeProduitDTO}.
   */
  allTypesProduits: TypeProduitDTO[];

  /**
   * Les {@link SelectItem}s représentant les {@link TypeProduitDTO}s.
   */
  allTypesProduitsItems: TypeProduitDTO[];

  idsTypeProduitSelected: number[] = [];

  globalFilterWrote: string;

  /**
   * Contient la liste des sites visibles par l'utilisateur connecté.
   */
  sitesUtilisateurConnecte: SiteDTO[];

  /**
   * Les {@link SelectItem}s représentant les sites visibles par l'utilisateur connecté.
   */
  sitesUtilisateurConnecteItems: SiteDTO[];

  idsSiteUtilisateurConnecteSelected: number[] = [];

  /**
   * Les {@link SelectItem}s représentant les sites visibles par l'utilisateur connecté.
   */

  allDeclinaisonsItems: DeclinaisonDTO[];

  idsDeclinaisonsSelected: number[] = [];

  /**
   * site selectionné pour la duplication d'un produit
   */
  duplicationSiteSelected: SiteDTO;

  produitToDuplicate: ProduitDTO;

  // Ligne dont le panneau de duplication est ouvert
  produitIdToDuplicate: number;

  loading: boolean;
  start: boolean = true;
  hasgestionproduitsiapro: boolean;
  hasgestionproduitsiprod: boolean;
  hasCreationDenree: boolean = false;
  hasCreationPlat: boolean = false;

  produitsForGrille: ProduitDTO[] = [];


  totalRecords: number;

  itemsProduitMenu: MenuItem[] = [];

  dataSource: CustomStore;

  subGlobalSearch: Subscription;
  subjectGlobalSearch: Subject<string> = new Subject<string>();
  globalSearch$ = this.subjectGlobalSearch.asObservable();

  gefAuditList: GefAuditDto[] = [];

  constructor(private produitsService: ProduitsService,
              private produitsDeclinaisonSvc: ProduitDeclinaisonService,
              private gfs: GenericFormService,
              public gds: GenericDatagridService,
              private regimesSvc: RegimeAlimentaireService,
              private cd: ChangeDetectorRef,
              private familleProduitSvc: FamillesProduitService,
              private typesProduitSvc: TypesProduitService,
              public produitsSvc: ProduitsService,
              private produitSvc: ProduitService,
              private routeMapSvc: RoutemapService,
              private searchService: SearchService,
              public auth2Svc: Auth2Service,
              public utils: UtilsService,
              public produitContrainteAlimSvc: ProduitContrainteAlimService,
              private declinaisonSvc: DeclinaisonsService,
              private dxSvc: DevextremeService,
              private toastSvc: ToastService,
              private textMessageService: TextMessageService,
              private graphQlSvc: GraphQLService,
              public gefSvc: GestionGefService) {
  }


  ngOnInit() {
    this.subscriptionGlobalFilterSearch();
    this.initDroits();
    // un produit a été supprimé, on doit rafraichir la grille
    this.produitDeletedSubscription();
    // un produit  a été enregistré ou modifié, on doit rafraichir la grille
    this.produitSaveSubscription();
    // un produit declinaison a été enregistré ou modifié, on doit rafraichir la grille
    this.produitDeclinaisonSaveSubscription();
    // un produit declinaison a été supprimé, on doit rafraichir la grille
    this.produitDeclinaisonDeleteSubscription();
    // mode iappro
    this.gestionProduitIApproSubscription();
    // pre renseigner le filtre des familles produits
    this.loadFilterFamillesProduitsSubscription();
    // pre renseigner le filtre des déclinaisons
    this.loadFilterDeclinaisonsSubscription();
    // pre renseigner le filtre des sites
    this.loadFilterSitesSubscription();
    this.loadRegimesSubscription();
    this.initCustomStore();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subGrilleProduits);
    this.utils.unsubscribe(this.subProduitSubject);
    this.utils.unsubscribe(this.subProduitSubjectToDelete);
    this.utils.unsubscribe(this.subAuth2);
    this.utils.unsubscribe(this.subDeleteProduit);
    this.utils.unsubscribe(this.subSaveProduitDeclinaison);
    this.utils.unsubscribe(this.subDeleteProduitDeclinaison);
    this.utils.unsubscribe(this.subFamillesProduits);
    this.utils.unsubscribe(this.subTypesProduits);
    this.utils.unsubscribe(this.subDeclinaisons);
    this.utils.unsubscribe(this.subRegimes);
    this.utils.unsubscribe(this.subGlobalSearch);
  }

  initDroits = (): void => {
    const droitsGestionProduits$ = combineLatest([
      this.auth2Svc.hasGestionProduitsIprod$,
      this.auth2Svc.hasGestionProduitsIapro$,
      this.auth2Svc.hasCreationDenree$,
      this.auth2Svc.hasCreationPlat$
    ]);
    droitsGestionProduits$.subscribe(res => {
      this.hasgestionproduitsiprod = res[0];
      this.hasgestionproduitsiapro = res[1];
      this.hasCreationDenree = res[2];
      this.hasCreationPlat = res[3];
      this.initItemsProduitMenu();
    });

  }

  initCustomStore = (): void => {
    this.dataSource = new CustomStore({
      key: 'id',
      load: (loadOptions: any) => {
        const pageSize: number = loadOptions.take || this.grid.instance.pageSize();
        const page: number = this.grid.instance.pageIndex();
        const sorts: Sort[] = this.dxSvc.dxToGrsSorts(loadOptions.sort);
        const filters: FilterItem[] = this.dxSvc.dxToGrsFilters(loadOptions.filter);

        const pagination: string = this.searchService.createPageUrlParam(new Page(page, pageSize));
        const sort: string = (sorts && sorts.length && sorts[0] && sorts[0].dir && sorts[0].path) ? `sort=${sorts[0].path},${sorts[0].dir}` : '';
        const urlParams: string = `${pagination}&${sort}`;

        const searchFilters: SearchProduitsFiltersDto = {
          siteIdList: this.auth2Svc.utilisateur.sites.map(item => item.id),
          fullText: this.globalFilterWrote || ''
        };

        if (this.idsSiteUtilisateurConnecteSelected && this.idsSiteUtilisateurConnecteSelected.length)
          searchFilters.siteIdList = this.idsSiteUtilisateurConnecteSelected;

        const filterCode = filters.find(filter => filter.column === 'code');
        if (filterCode)
          searchFilters.code = filterCode.value;

        const filterReference = filters.find(filter => filter.column === 'reference');
        if (filterReference)
          searchFilters.reference = filterReference.value;

        const filterProduit = filters.find(filter => filter.column === 'libelle');
        if (filterProduit)
          searchFilters.label = filterProduit.value;

        const filterActif = filters.find(filter => filter.column === 'actif');
        if (filterActif)
          searchFilters.actif = typeof filterActif.value === 'boolean'
            ? filterActif.value
            : filterActif.value === 'true';

        if (this.idsTypeProduitSelected && this.idsTypeProduitSelected.length)
          searchFilters.typeProduitIdList = this.idsTypeProduitSelected;

        if (this.idsDeclinaisonsSelected && this.idsDeclinaisonsSelected.length)
          searchFilters.declinaisonIdList = this.idsDeclinaisonsSelected;

        if (this.idsFamillesProduitsSelected && this.idsFamillesProduitsSelected.length)
          searchFilters.familleProduitIdList = this.idsFamillesProduitsSelected;

        if (this.idsRegimesSelected && this.idsRegimesSelected.length)
          searchFilters.regimeIdList = this.idsRegimesSelected;

        this.grid.instance.columnOption('produitContrainteAlimList', 'visible', false);

        return this.produitsService.search(urlParams, searchFilters, !this.hasgestionproduitsiprod && this.hasgestionproduitsiapro)
          .toPromise().then(result => {
            this.produitsForGrille = result.resultList;
            this.initGefAuditData(this.produitsForGrille.map(pd => pd.id))
            return {
              data: result.resultList,
              totalCount: result.totalElements
            }
          });
      },
      update: (key, values) => {
        return null;
      }
    });
  }

  initGefAuditData = (ids: number[]) => {
    if (this.auth2Svc.hasFeature(this.auth2Svc.utilisateur, HAS_GEF)) {
      this.gefSvc.findGefAuditList('ProduitDN', ids)
        .subscribe(response => {
          this.gefAuditList = response.allGefAuditList;
        })
    }
  }

  sortProduitsDeclines = (produitsDeclines: ProduitDeclinaisonDTO[]): ProduitDeclinaisonDTO[] => {
    produitsDeclines.sort((p1, p2) => p1?.declinaison?.libelle.localeCompare(p2?.declinaison?.libelle));
    return produitsDeclines;
  }

  announceGlobalFilterSearch = (e: any): void => {
    this.subjectGlobalSearch.next(e.value);
  }

  subscriptionGlobalFilterSearch = (): void => {
    this.subGlobalSearch = this.globalSearch$
      .pipe(debounceTime(500))
      .subscribe(searchValue => {
        this.globalFilterWrote = searchValue;
        this.grid.instance.refresh();
      });
  }

  onChangeSitesFilter = (event): void => {
    this.idsSiteUtilisateurConnecteSelected = event.value;
    this.grid.instance.refresh();
  }

  onChangeTypesProduitFilter = (event): void => {
    this.idsTypeProduitSelected = event.value;
    this.grid.instance.refresh();
  }

  findChildren = (allFamillesProduitsItems: FamilleProduitDTO[], selectedIds: number[]) => {
    let children = [];
    if (selectedIds.length === 0) return children;
    const directChildren = this.allFamillesProduitsItems.filter(fp => selectedIds.includes(fp.parent?.id));
    if (directChildren.length === 0) return children;
    children.push(...directChildren);
    directChildren.forEach(child => {
      children.push(...this.findChildren(allFamillesProduitsItems, children.map(c => c.id)));
    });
    return children;
  }

  onChangeFamillesProduitFilter = (event): void => {
    let selectedIds = event.value.filter(id => id);
    const newSelectedIds = selectedIds.filter(id => !this.idsFamillesProduitsSelectedPrevious.includes(id));
    const selectedChildren = this.findChildren(this.allFamillesProduitsItems, newSelectedIds);
    const unselectedIds = this.idsFamillesProduitsSelectedPrevious.filter(id => !selectedIds.includes(id));
    const unselectedChildren = this.findChildren(this.allFamillesProduitsItems, unselectedIds);

    if (selectedChildren.length > 0) {
      selectedChildren.forEach(child => {
        if (!selectedIds.includes(child.id))
          selectedIds.push(child.id)
      });
    }

    if (unselectedChildren.length > 0)
      selectedIds = selectedIds.filter(id => !unselectedChildren.some(child => child.id === id));

    const areArraysEqual =
      this.idsFamillesProduitsSelected.length === selectedIds.length &&
      this.idsFamillesProduitsSelected.every(id => selectedIds.includes(id));

    if (!areArraysEqual) {
      this.idsFamillesProduitsSelected = selectedIds;
      this.idsFamillesProduitsSelectedPrevious = this.idsFamillesProduitsSelected;
    }

    this.grid.instance.refresh();
  }

  onChangeDeclinaisonsFilter = (event): void => {
    this.idsDeclinaisonsSelected = event.value;
    this.grid.instance.refresh();
  }

  onChangeRegimesFilter = (event): void => {
    this.idsRegimesSelected = event.value;
    this.grid.instance.refresh();
  }

  /**
   * un produit  a été enregistré ou modifié, on doit rafraichir la grille
   */
  produitSaveSubscription = (): void => {
    this.subProduitSubject = this.produitsSvc.savedDto$.subscribe(() => {
      setTimeout(() => this.grid.instance.refresh(), 5000);
    });
  };

  /**
   * un produit declinaison a été supprimé, on doit rafraichir la grille
   */
  produitDeclinaisonDeleteSubscription = (): void => {
    this.subDeleteProduitDeclinaison = this.gfs.deletedId$.subscribe(() => this.grid.instance.refresh());
  };

  /**
   * abonnement à l'ajout/modification d'une declinaison dans la grille des produits
   */
  produitDeclinaisonSaveSubscription = (): void => {
    this.subSaveProduitDeclinaison = this.produitsDeclinaisonSvc.savedDto$.subscribe(() => this.grid.instance.refresh());
  };

  /**
   * Pré renseigner le filtre des déclinaisons
   */
  loadFilterDeclinaisonsSubscription = (): void => {
    const idsSites: number[] = this.auth2Svc.utilisateur.sites.map(s => s.id);
    this.subDeclinaisons = this.graphQlSvc.sendQuery(`
      {
          allDeclinaisons(filters: {
          siteIds: [${idsSites}]
        }) {
              id,
              libelle
          }
      }
    `).subscribe(response => {
      this.allDeclinaisonsItems = response.allDeclinaisons
        .map(declinaison => ({libelle: declinaison.libelle, id: declinaison.id}));
    });
  };

  loadFilterSitesSubscription = (): void => {
    this.sitesUtilisateurConnecteItems = this.auth2Svc.utilisateur.sites.map(site => ({
      libelle: site.libelle,
      id: site.id
    }));
  };

  /**
   * Pré renseigner le filtre des familles produits
   */
  loadFilterFamillesProduitsSubscription = (): void => {
    this.graphQlSvc.sendQuery(`
            {
              allFamillesDeProduit(filters: {
                siteIds: [${this.auth2Svc.utilisateur.sites.map(s => s.id)}],
                actif: true,
              }) {
                  id,
                  libelle,
                  parent { id, libelle }
              }
            }
          `)
      .toPromise()
      .then(response => {
        this.allFamillesProduitsItems = response.allFamillesDeProduit;
      });
  };

  loadRegimesSubscription = (): void => {
    this.subRegimes = this.getRegimesAlimentaires()
      .subscribe(response => this.allRegimesItems = response.allRegimesAlimentaires);
  }

  private getRegimesAlimentaires = (): Observable<any> => {
    return this.graphQlSvc.sendQuery(`
    {
      allRegimesAlimentaires {
        id,
        libelle,
      }
    }
    `);
  }

  /**
   * Un produit a été supprimé, on doit rafraichir la grille
   */
  produitDeletedSubscription = (): void => {
    this.subProduitSubjectToDelete = this.produitsService.produitSubjectToDelete$.subscribe(() => this.grid.instance.refresh());
  };

  openDialogBatch = (): void => {
    this.produitsSvc.announceOpenDialogBatch();
  }

  checkRatios = (): void => {
    this.produitSvc.checkRatios()
      .subscribe((res) => {
        if (res.one)
          this.produitSvc.announceOpenDialog(res.one);
      });
  }

  /**
   * En mode iappro, one ne doit voir que les denrees
   */
  gestionProduitIApproSubscription = (): void => {
    this.subAuth2 = this.auth2Svc.hasGestionProduitsIapro$.pipe(
      switchMap(data => {
        this.hasgestionproduitsiapro = data;
        return this.auth2Svc.hasGestionProduitsIprod$;
      }),
      switchMap(data => {
        this.hasgestionproduitsiprod = data;
        return this.gds.getAll(this.typesProduitSvc.getEntityName(), this.typesProduitSvc.getSort(), true);
      }),
      switchMap(response => {
        if (!this.hasgestionproduitsiprod && this.hasgestionproduitsiapro)
          this.allTypesProduits = this.typesProduitSvc.getTypesProduits(response.resultList, false);
        else
          this.allTypesProduits = response.resultList;
        this.allTypesProduitsItems = this.allTypesProduits.map(typeProduit => ({
          libelle: typeProduit.libelle,
          id: typeProduit.id
        } as TypeProduitDTO));
        return of(null);
      }),
      catchError(err => this.utils.handleError(err))
    ).subscribe();
  };

  initItemsProduitMenu = (): void => {
    this.itemsProduitMenu = [
      {
        disabled: !this.hasCreationDenree,
        visible: this.hasCreationDenree,
        label: 'Créer une denrée',
        icon: 'fas fa-apple-alt',
        command: (event) => this.openNewProduit(false)
      },
      {
        disabled: !this.hasCreationPlat,
        visible: this.hasCreationPlat,
        label: 'Créer un plat',
        icon: 'fas fa-utensils',
        command: (event) => this.openNewProduit(true)
      }
    ];
  };

  canCreateProduit = (): boolean => this.hasCreationDenree || this.hasCreationPlat;

  openFicheIdentite = (produit: ProduitDTO): void => {
    this.routeMapSvc.goToSecondaryRoute(['gestionproduits', 'produit', produit.typeProduit.fabrique, produit.id, 'ficheidentite']);
  };

  confirmDelete = async (produit: ProduitDTO): Promise<void> => {
    const message = this.textMessageService.getProduitDeletionMessage(produit)
    const result = confirm(message, 'Suppression du produit');
    const isDeleted: boolean = await result;
    if (isDeleted) {
      this.produitsService.deleteProduit(produit)
        .subscribe(() => {
          this.grid.instance.refresh();
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Le produit ${produit?.libelle} a été supprimé avec succès`);
        });
    }
  };

  openNewProduit = (isFabrique: boolean): void => {
    this.routeMapSvc.goToSecondaryRoute(['gestionproduits', 'produit', isFabrique, 0, 'ficheidentite']);
  };

  canCreate = (): boolean => this.auth2Svc.hasSitesLocaux();

  tooltipCreationDeclinaison = (): string => {
    if (!this.canCreate())
      return '';
    return 'Ajouter une déclinaison';
  };


  /**
   * ouverture p-overlayPanel pour la duplication de produit
   * @param $event
   * @param rowData
   */
  openPanelDuplication = ($event, rowData: ProduitDTO): void => {
    this.duplicationSiteSelected = this.auth2Svc.utilisateur.siteListLocaux.length === 1 ? this.auth2Svc.utilisateur.siteListLocaux[0] : undefined;
    // la ligne de la grille ne porte pas tous les champs du produit (ratioVolume, uniteDeMesure...) : on charge le produit complet
    this.produitToDuplicate = undefined;
    this.produitIdToDuplicate = rowData.id;
    // en cas d'échec du GET, handleError renvoie l'erreur HTTP comme valeur ; une réponse arrivée après l'ouverture d'une autre ligne est ignorée
    this.produitsService.getProduitById(rowData.id).subscribe((produit: ProduitDTO) => {
      if (produit?.id === this.produitIdToDuplicate) this.produitToDuplicate = produit;
    });
    this.opDuplication.toggle($event);
  };

  /**
   * Appel le service pour dupliquer le produits en base
   * @param produitToDuplicate
   * @param duplicationSite
   */
  duplicateProduit = (): void => {
    // Même en erreur (ex. échec de la copie des articles), le produit peut être déjà créé : on rafraîchit et on ferme
    // dans tous les cas, pour qu'un second clic ne le duplique pas une seconde fois
    this.produitsService.duplicateProduitPlat(this.produitToDuplicate, this.duplicationSiteSelected)
      .pipe(finalize(() => {
        this.grid.instance.refresh();
        this.opDuplication.hide();
        this.produitToDuplicate = undefined;
      }))
      .subscribe((response: ResponseWrapper<ProduitDTO>) => {
        if (!this.utils.displayAvertissementList(response, MSG_KEY.ROOT))
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Produit dupliqué avec succès.`);
        this.produitsService.announceSavedDTO(response);
        this.openFicheIdentite(response.one);
      });
  };

  canModify(element: ObjectDTO): boolean {
    if (!element || !element?.site || !element?.site.id)
      return true;
    return this.auth2Svc.isSiteLocal(element.site.id);
  }

  openColumnChooser(grid: DxDataGridComponent) {
    grid.instance.showColumnChooser();
  }

  hasDeclinaisonSansApportNutri(produit: ProduitDTO): boolean {
    return produit?.produitDeclinaisons?.some(pd => pd.hasDenreeSansApportNutri) ?? false;
  }
}
